import { render, staticRenderFns } from "./mainVis.vue?vue&type=template&id=467ad4f2&scoped=true&"
import script from "./mainVis.vue?vue&type=script&lang=js&"
export * from "./mainVis.vue?vue&type=script&lang=js&"
import style0 from "./mainVis.vue?vue&type=style&index=0&id=467ad4f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ad4f2",
  null
  
)

export default component.exports